// Pilote toutes les listes scroll-snap qui portent [data-hc-snap] : « Home categories » et la
// sélection d'avis. Les deux sections émettent ce même <script src>, et deux nœuds <script> de
// même URL sont téléchargés une fois mais EXÉCUTÉS deux fois - d'où le verrou, sans lequel une
// flèche défile de deux pas.
//
// Deux modes, pour ne pas changer le comportement d'une section en servant l'autre :
//   [data-hc-snap]                  -> les flèches avancent d'une tuile (Home categories)
//   [data-hc-snap][data-hc-pages]   -> elles avancent d'une page entière, et le conteneur
//                                      [data-hc-dots] reçoit un point par page (sélection d'avis)
(() => {
  if (window.__mnlHcSnap) return;
  window.__mnlHcSnap = true;

  const bind = (root) => {
    const scroller = root.querySelector(".hc-scroller");
    if (!scroller) return;

    const prev = root.querySelector(".hc-btn--prev");
    const next = root.querySelector(".hc-btn--next");
    const paged = root.hasAttribute("data-hc-pages");
    const dots = paged ? root.querySelector("[data-hc-dots]") : null;

    const getStep = () => {
      const first = scroller.querySelector(".hc-item");
      if (!first) return scroller.clientWidth;
      const styles = getComputedStyle(scroller);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return first.getBoundingClientRect().width + gap;
    };

    // `floor` et pas `round` : la carte de la page suivante dépasse exprès, et arrondir au-dessus
    // ferait avancer d'une carte de plus que ce qui est visible, donc sauter du contenu.
    const perPage = () => Math.max(1, Math.floor(scroller.clientWidth / getStep()));
    const pageWidth = () => perPage() * getStep();
    const pageCount = () => Math.max(1, Math.ceil(scroller.querySelectorAll(".hc-item").length / perPage()));

    const currentPage = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (scroller.scrollLeft >= maxScroll - 1) return pageCount() - 1;
      return Math.min(pageCount() - 1, Math.round(scroller.scrollLeft / pageWidth()));
    };

    const paintDots = () => {
      if (!dots) return;
      const total = pageCount();

      // Une seule page : pas de pagination à afficher.
      if (total < 2) {
        dots.textContent = "";
        return;
      }

      if (dots.children.length !== total) {
        dots.textContent = "";
        for (let i = 0; i < total; i += 1) {
          const dot = document.createElement("button");
          dot.type = "button";
          dot.setAttribute("aria-label", "Page " + (i + 1) + " sur " + total);
          dot.addEventListener("click", () => {
            scroller.scrollTo({ left: i * pageWidth(), behavior: "smooth" });
          });
          dots.appendChild(dot);
        }
      }

      const active = currentPage();
      for (let i = 0; i < dots.children.length; i += 1) {
        if (i === active) dots.children[i].setAttribute("aria-current", "true");
        else dots.children[i].removeAttribute("aria-current");
      }
    };

    const update = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const x = scroller.scrollLeft;

      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= maxScroll - 1;

      paintDots();
    };

    const step = () => (paged ? pageWidth() : getStep());

    prev?.addEventListener("click", () => {
      scroller.scrollBy({ left: -step(), behavior: "smooth" });
    });

    next?.addEventListener("click", () => {
      scroller.scrollBy({ left: step(), behavior: "smooth" });
    });

    scroller.addEventListener("scroll", () => {
      window.requestAnimationFrame(update);
    });

    window.addEventListener("resize", update);

    update();
  };

  const init = () => document.querySelectorAll("[data-hc-snap]").forEach(bind);

  // Le fichier est charge en `defer`, donc normalement avant DOMContentLoaded. La branche `else`
  // couvre le cas ou l'editeur de theme reinjecte la section apres coup.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
